import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonList, IonItem,
   IonLabel,
   IonImg,
   IonButton,
   IonIcon,
   IonSpinner,
   IonSearchbar,
   IonGrid,
   IonRow,
   IonCol,
   IonInfiniteScroll,
   IonInfiniteScrollContent,
   IonToast,
   IonProgressBar,
   IonMenu,
   IonMenuToggle,
   IonListHeader
} from '@ionic/react';
import React, { useState, useEffect } from 'react';
import { withRouter, useParams } from "react-router";
import { useHistory } from 'react-router-dom';
import './MyTasks.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import { caretForwardOutline, checkmarkCircle, logOut, pencil, refresh, refreshOutline, settings } from 'ionicons/icons';
import Util from '../../../services/Util';

type MyTasksParams = {
  dmy:string
}

const MyTasks: React.FC = () => {

  const {dmy} = useParams<MyTasksParams>();

  const [error, setError] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [errColor, setErrColor] = useState("danger");
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState(false);
  const [start, setStart] = useState(0);
  const [limit, setLimit] = useState(20);
  const [taskCount, setTaskCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [noMoreTask, setNoMoreTask] = useState(false);
  const [title, setTitle] = useState("BLEAF Mobile");
  const [titleFormat, setTitleFormat] = useState("BLEAF Mobile");
  const [title2, setTitle2] = useState("My Tasks");
  const [titleFormat2, setTitleFormat2] = useState("My Tasks");
  
  const server = new ServerService();
  var state = server.state;
  const history = useHistory();
  server.setHistory(history);

  const util = new Util();

  const [accountName, setAccountName] = useState(server.accounts[server.activeAcc].name);

  const now = new Date();
  const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();

  const fetchTasks = function(state:any, retry:boolean) {
    console.log("fetchTask("+state+" , "+retry+")")
    console.log("tasks.length:"+tasks.length+", start:"+start+" ,limit:"+limit)
    setLoading(true);
    
    const data = {
      ck:state.customerKey,
      s:searchTerm,
      st:(start>=0 ? start : 0).toString(),
      lm:limit.toString()
    }
    fetch(server.getFullUrl("mb/task/list", data),server.getRequest())
      .then(res => res.json()
      .then(
        (result) => {
          setLoading(false);
          setTasks([...tasks, ...result]);

          setTaskCount(tasks.length + result.length);

          setStart((start>=0 ? start : 0) + (result ? result.length : 0));

          setDisableInfiniteScroll(!result || result.length < limit);
          setNoMoreTask(start>0 && (!result || result.length< limit));
          console.log("disableInfiniteScroll:"+(!result || result.length < limit))
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.log("fetchTask err 1");
          setStart(0);
          setLoading(false);
          if (retry) {
            server.login((success:boolean, msg:string) => {
              if (success) {
                console.log("fetchTask success");
                fetchTasks(server.state, false)
              } else {
                console.log("fetchTask err 2");
                setErrMsg(msg);
                setError(true);
              }
            });
          } else {
            console.log("fetchTask err 3");
            setErrMsg(error);
            setError(true);
          }
        }
     ).catch(e => {
        console.log("fetchTask err 4");
        setErrMsg(e);
        setError(true);
        setLoading(false);
     })
    ).catch(e => {
        console.log("fetchTask err 5");
        setErrMsg("Please check Internet Connection!");
        setErrColor("dark");
        setError(true);
        setLoading(false);
    })
  }

  const taskStatusImage = function(status:any) {
    var img = "";
    if (!status) {
      img = "white";
    } else
    if (status.indexOf("REJECT") > -1) {
      img = "red";
    }
    else
    if (status.startsWith("RE") && status.endsWith("SUBMIT")) {
      img = "yellow";
    }
    else {
      img = "green";
    }
    
    return "assets/img/led"+img+".png";
  }

  const taskStatusImageShort = function(color:any) {
    return "assets/img/led"+color+".png";
  }

  const loadData = async (event:CustomEvent<void>) => {
      console.log("loadData()");
      await fetchTasks(state, true);
      (event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const fetchSystemConfig = function(state:any, retry:boolean) {
    //server.log("fetchSystemConfig("+state+" , "+retry+")")
    const data = {
      p1:"MOBILE_MY_TASK_PAGING,MOBILE_MY_TASK_TITLE,MOBILE_MY_TASK_TITLE2",
    }

    fetch(server.getFullUrl("srcUrl/main/systemConfigs", data),server.getRequest())
      .then(res => res.json()
      .then(
        (result) => {
          if (result.success) {
            // server.log("flag1:"+(result.data[0] ? result.data[0].name : ""))
            // if (result.data[0] && result.data[0].name) {
            //   setLimit(parseInt(result.data[0].name));
            // }
            for(var a in result.data) {
              server.log("code:"+result.data[a].code);
              if (result.data[a].code === "MOBILE_MY_TASK_PAGING") {
                server.log("flag1:"+(result.data[a] ? result.data[a].flag1 : ""))
                if (result.data[a] && result.data[a].flag1) {
                  setLimit(parseInt(result.data[a].flag1));
                }
              } else 
              if (result.data[a].code === "MOBILE_MY_TASK_TITLE") {
                server.log("flag1:"+(result.data[a] ? result.data[a].flag1 : ""))
                if (result.data[a] && result.data[a].flag1) {
                  setTitleFormat(result.data[a].flag1);
                }
              } else 
              if (result.data[a].code === "MOBILE_MY_TASK_TITLE2") {
                server.log("flag1:"+(result.data[a] ? result.data[a].flag1 : ""))
                if (result.data[a] && result.data[a].flag1) {
                  setTitleFormat2(result.data[a].flag1);
                }
              }
            }
            setTasks([]);
            setStart(start === -1 ? -2 : -1);
          }
        },
        (error) => {
          server.log("systemConfig err 1");
          if (retry) {
            /*
            server.login((success:boolean, msg:string) => {
              if (success) {
                server.log("systemConfig success");
                fetchSystemConfig(state, false)
              } else {
                */
                server.log("systemConfig err 2");
                setStart(0)
                setTasks([]);
                setErrMsg("Error: Can't connect server");
                setError(true);
                /*
              }
            });
            */
          } else {
            server.log("systemConfig err 3");
            setStart(0)
            setTasks([]);
            setErrMsg(error);
            setError(true);
          }
        }
     ).catch(e => {
        server.log("systemConfig err 4");
        setErrMsg(e);
        setError(true);
     })
    ).catch(e => {
        server.log("systemConfig err 5");
        setErrMsg("Please check Account Settings or Internet Connection!");
        setErrColor("dark");
        setError(true);
    })
  }

  useEffect(() => {
    console.log("MyTasks : useEffect 3,"+dmy);
    state = server.state
  }, [dmy])

  useEffect(() => {
    console.log("MyTasks : useEffect 2,"+start)
    if (start < 0) {
      setTaskCount(0)
      setDisableInfiniteScroll(false)
      fetchTasks(state, true)

      updateTitle()
    }
  }, [start])

  useEffect(() => {
    console.log("MyTasks : useEffect")

    fetchSystemConfig(state, true);

  }, [state, searchTerm])

  useEffect(() => {
    console.log("MyTasks : useEffect 4,"+taskCount);

    updateTitle()
  }, [taskCount,accountName])

  const updateTitle = () => {
    var c = null;
    eval("c = `"+titleFormat+"`")
    setTitle(c)

    var c = null;
    eval("c = `"+titleFormat2+"`")
    setTitle2(c)
  }

    return (
      <>
      <IonMenu type="overlay" side="end" contentId="main-content" menuId="end-menu" auto-hide={false}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Settings</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
        <IonMenuToggle menu="end-menu" auto-hide={true}>
          <IonList>
            <IonItem button detail={true} detailIcon={caretForwardOutline} className="ion-no-padding" routerLink={"/page/home/mytasks/signature/"+dummy}>
                <IonIcon aria-hidden="true" icon={pencil} slot="start"></IonIcon>
                <IonLabel>Signature</IonLabel>
            </IonItem>
          </IonList>
          </IonMenuToggle>
        </IonContent>
      </IonMenu>

      <IonPage id="main-content">
        <IonHeader>
          <IonToolbar style={{"color":"#3880ff"}}>
            <IonButtons slot="start">
              <IonMenuButton />
              <OpenMenuButton />
            </IonButtons>
              <IonTitle>{title}</IonTitle>
            <IonButtons slot="end">
              <IonMenuButton menu="end-menu">
                  <IonIcon icon={settings}></IonIcon>
              </IonMenuButton>
              {(server.state.logout == "1") && (
              <IonButton size="large" onClick={e => {
                                server.logout();
                                window.location.href = "/page/login";
              }}><IonIcon icon={logOut}></IonIcon></IonButton>
              )}
            </IonButtons>
          </IonToolbar>

          <IonToolbar>
            <IonButtons slot="start">
              <IonTitle>{title2}</IonTitle>
              {loading ?(
                 <><IonSpinner slot="end" name="lines" color="primary"/><IonLabel slot="end">&nbsp;</IonLabel></>
               ):""}
              <IonButton hidden={loading} onClick={e => {setStart(start===-1 ? -2 : -1);setTasks([])}}><IonIcon icon={refresh}></IonIcon></IonButton>
            </IonButtons>
          </IonToolbar>

        </IonHeader>
        <IonContent>
          <IonSearchbar value={searchTerm} debounce={1000} onIonChange={e => {setSearchTerm(e.detail.value)}}>
          </IonSearchbar>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle>{title}</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonList>
          <IonGrid>
          {tasks.map((task,i) => {
                return(
                  <IonItem key={i} detail={true} className="ion-no-padding" routerLink={"/page/home/mytasks/task/"+task.id+"/"+task.type+"/"+dummy} onClick={(e) => {server.task = task}}>
                  <IonRow key={i+"_"+i} className="ion-align-items-start">
                  <IonCol size="auto"><IonImg src={(!task.v) || (task.v < '000409') ? taskStatusImage(task.status) : taskStatusImageShort(task.color)}/></IonCol>
                  <IonCol>
                    <IonLabel className="ion-text-wrap">
                    <span dangerouslySetInnerHTML={{__html: task.desc}}></span>
                    </IonLabel>
                  </IonCol>
                  </IonRow>
                  </IonItem>
                )
            })}
          </IonGrid>

          <IonItem className={loading ? '' : 'ion-hide'}>
            <IonProgressBar type="indeterminate"></IonProgressBar>
          </IonItem>

          </IonList>

          <IonInfiniteScroll threshold="10%" disabled={disableInfiniteScroll} onIonInfinite={loadData}>
          <IonInfiniteScrollContent
            loadingSpinner="circles"
            loadingText="Loading more tasks...">
          </IonInfiniteScrollContent>
          </IonInfiniteScroll>

          <IonToast
            isOpen={noMoreTask}
            message={'No More Task'}
            duration={2000}
            onDidDismiss={() => setNoMoreTask(false)}
            position="middle"
          />

          <IonToast
            isOpen={error}
            message={errMsg}
            position="middle"
            color={errColor}
            buttons={[
              {
                side: 'end',
                icon: checkmarkCircle,
                text: 'OK',
                role: 'cancel',
                handler: () => {
                  setError(false);
                  setErrColor("danger");
                  setLoading(false);
                }
              },{
                text:'Refresh',
                icon: refreshOutline,
                handler: () => {
                  setError(false);
                  setErrColor("danger");
                  window.location.reload();
                }
              }
            ]}
          />

        </IonContent>

      </IonPage>
      </>
    );
}

export default withRouter(MyTasks);
